import { render, staticRenderFns } from "./addQuestionItem.vue?vue&type=template&id=6872e7a6&scoped=true&"
import script from "./addQuestionItem.vue?vue&type=script&lang=js&"
export * from "./addQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionItem.vue?vue&type=style&index=0&id=6872e7a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6872e7a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6872e7a6')) {
      api.createRecord('6872e7a6', component.options)
    } else {
      api.reload('6872e7a6', component.options)
    }
    module.hot.accept("./addQuestionItem.vue?vue&type=template&id=6872e7a6&scoped=true&", function () {
      api.rerender('6872e7a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/surveyQquestionnaire/components/addQuestionItem.vue"
export default component.exports